import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TextInput } from "../../core/components/input/TextInput";
import { InfoText } from "../../core/components/texts/InfoText";
import {
  getAppointmentPatientNote,
  getAppointmentTimeSlots,
} from "../../core/store/appointmentSlice";
import { getChainConfig, getCurrentPracticeId } from "../../core/store/chainSlice";
import { useMainStore } from "../../core/store/mainStore";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";
import { TimeSlotTable } from "./components/TimeSlotTable";
import { buildPatientTimeslotTableModel } from "./utils/appointmentTimeslotUtils";

export const AppointmentTimeSlotScreen = () => {
  const { t } = useTranslation();

  const setAppointmentTimeSlots = useMainStore(
    (state) => state.setAppointmentTimeSlots,
  );
  const setAppointmentPatientNote = useMainStore(
    (state) => state.setAppointmentPatientNote,
  );
  const infoText = useMainStore(getAppointmentPatientNote);
  const timeSlots = useMainStore(getAppointmentTimeSlots);
  const chainConfig = useMainStore(getChainConfig);
  const practiceId = useMainStore(getCurrentPracticeId);

  const tableModel = useMemo(
    () => buildPatientTimeslotTableModel(chainConfig, practiceId, t),
    [chainConfig, practiceId, t],
  );

  useEffect(() => {
    if (!timeSlots?.length) return;
    const pruned = timeSlots.filter((s) => tableModel.validSlotIds.has(s));
    if (pruned.length !== timeSlots.length) {
      setAppointmentTimeSlots(pruned.length > 0 ? pruned : undefined);
    }
  }, [tableModel, timeSlots, setAppointmentTimeSlots]);

  return (
    <AppointmentScreenWrapper
      nextButtonDisabled={!timeSlots || timeSlots.length === 0}>
      <InfoText
        headline={t("APPOINTMENT_TIME_SLOTS_HEADLINE")}
        text={[t("APPOINTMENT_TIME_SLOTS_DESCRIPTION")]}
      />
      <VerticalContainer>
        <TimeSlotTable
          tableModel={tableModel}
          selectedSlots={timeSlots || []}
          onSelectionChange={setAppointmentTimeSlots}
        />
        <TextInput
          placeholder={t("APPOINTMENT_TIME_SLOTS_NOTES_PLACEHOLDER")}
          value={infoText}
          onChange={setAppointmentPatientNote}
          withoutError
        />
      </VerticalContainer>
    </AppointmentScreenWrapper>
  );
};

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
